import { ButtonHTMLAttributes } from 'react'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  styleType?: 'default' | 'outline' | 'danger'
  colored?: boolean
  children: React.ReactNode
}

const Button: React.FC<ButtonProps> = ({
  styleType = 'default',
  colored = false,
  type,
  className,
  children,
  ...props
}) => (
  <button
    className={`shrink-0 cursor-pointer rounded-lg px-5 py-[10px] shadow-md transition-opacity hover:opacity-90 disabled:cursor-not-allowed disabled:hover:opacity-100 ${
      styleType === 'outline'
        ? `border ${
            colored
              ? 'border-primary text-primary'
              : 'border-gray-400 text-gray-400'
          }`
        : styleType === 'danger'
          ? 'bg-error text-white'
          : 'bg-primary text-white'
    } disabled:border-gray-300 disabled:bg-gray-300 disabled:text-gray-500 ${className || ''} `}
    type={type || 'button'}
    {...props}
  >
    {children}
  </button>
)

export default Button
